var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSodexo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 24,
    height: 18,
    rx: 3,
    fill: "#294699"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2043 8.41625C16.6824 7.27938 17.1458 6.13792 17.6458 5.00012C17.7715 6.16361 17.9193 7.30507 18.0587 8.47131C19.0378 8.09602 20.0031 7.651 20.9968 7.32342C20.2976 8.29513 19.6195 9.29988 18.9424 10.2936C19.6783 10.957 20.4224 11.5856 21.1446 12.2563C20.1572 12.3701 19.1699 12.4251 18.1909 12.5215C18.1551 13.707 18.0817 14.9063 18.0294 16.1101C17.4541 15.2384 16.932 14.3548 16.3796 13.4739C15.5712 14.3282 14.738 15.1751 13.9508 16.0477C14.2526 14.8365 14.5619 13.6253 14.8564 12.4141C13.9131 12.282 12.9414 12.1242 12 11.9801C12.9277 11.3837 13.8618 10.7836 14.7821 10.1725C14.4141 9.13013 14.0159 8.09969 13.648 7.07292C14.4949 7.54456 15.3574 7.95288 16.2043 8.41625Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSodexo);
export default __webpack_public_path__ + "static/media/sodexo.bd13ebc25f8da61b7f3f1103bc3aa7a8.svg";
export { ForwardRef as ReactComponent };